import RegistrationFooter from "apps/registration/components/registrationFooter";
import { useConsent } from "context/consent";
import React from "react";
import { CookieManager } from "shared/consentManagement/enum";
import { useCopies } from "shared/hooks/useCopies";

export function CookiePage() {
  const { consentCopy } = useConsent();
  const wrapperRef = React.useRef<HTMLDivElement>(null);
  const copies = useCopies();
  React.useEffect(() => {
    const canLoadDynamicDataFromOneTrust =
      consentCopy &&
      consentCopy.gdprConsentEnabled &&
      consentCopy.gdprConfigMetadata.manager === CookieManager.ONE_TRUST;
    if (canLoadDynamicDataFromOneTrust) {
      window.OneTrust?.initializeCookiePolicyHtml?.();
      wrapperRef.current?.scrollIntoView?.();
    }
  }, [consentCopy]);
  return (
    <React.Fragment>
      <div className="container cookiesPageWrapper">
        <h1 className="cookiesPage--title" ref={wrapperRef}>
          {copies.get("cookie.policy")}
        </h1>
        {consentCopy?.gdprConfigMetadata.staticContainerDescriptionForThirdParty && (
          <div
            className="cookiesPage--contentHolder"
            dangerouslySetInnerHTML={{
              __html: consentCopy?.gdprConfigMetadata.staticContainerDescriptionForThirdParty
            }}
          />
        )}
        {/* One trust loads content in this div do not change the Id*/}
        <div id="ot-sdk-cookie-policy"></div>
      </div>
      <RegistrationFooter />
    </React.Fragment>
  );
}
